import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  // Timer Calculations
  const competitionDate = new Date("2025-06-17T06:30:00");
  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = competitionDate - now;
    let timeLeft = {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00'
    };
    if (difference > 0) {
      timeLeft = {
        days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(2, '0'),
        hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(2, '0'),
        minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(2, '0'),
        seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const cars = [
    {
      title: '2024–25 EV',
      description: 'Coming Soon!',
      image: `${process.env.PUBLIC_URL}/car/2324-2.jpg`,
    },
    {
      title: '2023–24 EV',
      description: 'Mid-engine electric platform built for precision and acceleration.',
      image: `${process.env.PUBLIC_URL}/car/2324-2.jpg`,
    },
    {
      title: '2022–23 EV',
      description: 'Rear-engine combustion design with optimized suspension geometry.',
      image: `${process.env.PUBLIC_URL}/car/2324-2.jpg`,
    },
    {
      title: '2021–22 IC',
      description: 'Rear-engine combustion design with optimized suspension geometry.',
      image: `${process.env.PUBLIC_URL}/car/2324-2.jpg`,
    },
    {
      title: '2020–21 IC',
      description: 'First-gen EV prototype with custom drivetrain and telemetry.',
      image: `${process.env.PUBLIC_URL}/car/2324-2.jpg`,
    },
    {
      title: '2019–20 EV',
      description: 'Lightweight chassis and track-ready aerodynamics.',
      image: `${process.env.PUBLIC_URL}/car/2324-2.jpg`,
    },
  ];

  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero-section">
        <video autoPlay loop muted playsInline className="hero-video">
          <source src={`${process.env.PUBLIC_URL}/car/hero_short.mov`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
        <div className="overlay-content">
          <img src={`${process.env.PUBLIC_URL}/logos/LogoWhite.png`} alt="Logo" className="logo" />
          <h1 className="heading">Columbia University Formula Racing</h1>
          <div className="stats-button-container">
            <Link to="/join" className="button">JOIN US</Link>
            <a href="https://securepay.cuit.columbia.edu/payment/pub/cufrsponsorships/" className="donate-button">Donate</a>
          </div>
        </div>
      </section>

      <section className="ev26-preview-section">
        <img src="/ev26/26-2.jpg" alt="EV26 Preview" className="ev26-preview-image" />
        <div className="ev26-preview-overlay">
          <h2 className="ev26-preview-title">INTRODUCING EV26</h2>
          <p className="ev26-preview-text">
            Built by 200+ Columbia engineers, EV26 blends power, precision, and team spirit.
          </p>
          <Link
            to="/cars"
            replace
            className="ev26-preview-button"
            onClick={() => window.scrollTo(0, 0)}
          >
            Explore the Car →
          </Link>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <img
          src={`${process.env.PUBLIC_URL}/groups/team_wide.png`}
          alt="Team Stats"
          className="stats-image"
        />
        <div className="stats-overlay">
          <h2 className="stats-heading">JOIN COLUMBIA'S LARGEST ENGINEERING CLUB</h2>
          <p className="stats-text">230 MEMBERS, 24 SPONSORS, 17 E-BOARD</p>
          <div className="stats-button-container">
            <Link to="/about" className="small-button">ABOUT</Link>
            <Link to="/sponsors" className="small-button">SPONSORS</Link>
            <Link to="/join" className="small-button">JOIN</Link>
          </div>
        </div>
      </section>

      {/* Cars Section (commented out) */}
      {/* <section className="cars-section">
        <h2 className="section-title">OUR CARS</h2>
        <p className="section-text">
          Explore some of our recent vehicles — each designed, built, and tested by Columbia students.
        </p>
        <div className="cars-grid">
          {cars.map((car, i) => (
            <div
              key={i}
              className="car-card"
              style={{ backgroundImage: `url(${car.image})` }}
            >
              <div className="car-overlay"></div>
              <div className="car-content">
                <div className="car-title">{car.title}</div>
                <div className="car-desc">{car.description}</div>
              </div>
            </div>
          ))}
        </div>
      </section> */}
    </div>
  );
}

export default Home;

